module.exports = __webpack_public_path__ + "img/teacher.d307d23b.png";